import { i18n } from 'i18n';
import {
  makeDeleteMutation,
  makeGetQuery,
  makeUpdateMutation
} from './useApi';
import {
  FileResponse,
  HistoricBreakingTestImportBatchDto,
  HistoricBreakingTestImportDto
} from './api';
import { BREAKING_SCHEDULES_KEY } from './useBreakingSchedules';

export const HISTORIC_IMPORT_BATCHES_KEY = 'historic-import-batches';

export const useHistoricImportBatchesQuery = makeGetQuery<HistoricBreakingTestImportBatchDto[], string>(
  HISTORIC_IMPORT_BATCHES_KEY,
  (api, mineModelId) => () => api.historicBreakingTests.getImportBatches(mineModelId),
);

export const useImportHistoricBreakingTestsMutation = makeUpdateMutation<FileResponse, HistoricBreakingTestImportDto[]>(
  HISTORIC_IMPORT_BATCHES_KEY,
  BREAKING_SCHEDULES_KEY,
  (api, mineModelId) => (importRows) => api.historicBreakingTests.importHistoricBreakingTests(mineModelId, importRows),
  () => i18n._('Import Complete'),
);

export interface DeleteHistoricImportBatchMutation {
  mineModelId: string;
  importedDateUtc: string;
}

export const useDeleteHistoricImportBatchMutation = makeDeleteMutation<void, DeleteHistoricImportBatchMutation>(
  HISTORIC_IMPORT_BATCHES_KEY,
  BREAKING_SCHEDULES_KEY,
  (api) => (mutation) => api.historicBreakingTests.deleteHistoricBreakingTestImport(mutation.mineModelId, mutation.importedDateUtc),
  () => i18n._('Historic import deleted'),
  (mutation) => mutation.mineModelId,
);
